import React from 'react';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { AUTH_PROFILE_LIMITS } from 'apps/auth/constants/UrlConstants';

const RetryConfirmIntro = (props) => {
    let navBarProps = {};
    if (props.secondButton) {
        navBarProps = {
            topButtonType: 'link',
            topButtonCaption: props.secondButton,
            topButtonLink: props.secondButtonLink ? props.secondButtonLink : AUTH_PROFILE_LIMITS,
        };
    }

    return (
        <InfoPage
            {...navBarProps}
            iconName={props.icon}
            iconColor="primary"
            headerText={<DangerouslyHtml dangerouslyHtml={props.title} />}
            secondaryText={<DangerouslyHtml dangerouslyHtml={props.text} />}
            buttonRowCaption={props.link}
            buttonRowOnClick={props.linkClick}
            buttonRowType="link"
            primaryButtonCaption={props.firstButton}
            primaryButtonType="link"
            primaryButtonLink={props.firstButtonLink}
        />
    );
};

export default RetryConfirmIntro;
